module.exports = __webpack_public_path__ + "static/media/highway-rider-extreme.494b28dc.jpeg";